import { render, staticRenderFns } from "./CargasSugal.vue?vue&type=template&id=635bb320&"
import script from "./CargasSugal.vue?vue&type=script&lang=ts&"
export * from "./CargasSugal.vue?vue&type=script&lang=ts&"
import style0 from "./CargasSugal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('635bb320', component.options)
    } else {
      api.reload('635bb320', component.options)
    }
    module.hot.accept("./CargasSugal.vue?vue&type=template&id=635bb320&", function () {
      api.rerender('635bb320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Sugal/CargasSugal.vue"
export default component.exports